export default "__VITE_PUBLIC_ASSET__c145ab7e__"